<div class="dtf-accountdetails">
  <!--Announcement Banner Code-->
  <div class="dtf-alertpage"></div>


  <div *ngIf="bodyLoaded()" class="mbfs-payoff-quote-spinner">

    <!--Default page to load while waiting for Redirection to Classic-->
    <section class="mbfs-home-hero"
      style="background-image: url(/static/assets/img/dtf-assets/images/redesign/mbfs_top_image_and_tint.jpg);">
      <section class="mbfs-home-hero__header">
        <h2 class="mbfs-home-hero__header-subtitle">
          {{ 'LoaderPages.BannerHeader' | translate }}
        </h2>
        <p class="mbfs-home-hero__header-text-demi">
          {{ 'LoaderPages.Loading' | translate }}
        </p>

        <!--Spinner-->
        <div class="mbfs-loading-spinner-overlay"></div>
        <div class="mbfs-loading-spinner"> </div>
      </section>
    </section>
  </div>

  <div class="container_dashboard">
    <h4 class="dtfbrochures__header_dark">{{ 'AccountDetails.Header' | translate }}</h4>
    <div class="dtfbrochures__containerlong">
      <div class="row4">
        <div class="dynamicflexbox">
          <section class="section">
            <div class="section__item section__item--start">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.NumAccounts' | translate }}</h4>
              <h3 class="dtfbrochures__header6">{{rowCount()}}</h3>
            </div>
            <div class="section__item section__item--end">
              <h4 class="dtfbrochures__header5">{{ 'Dashboard.CurrentDue' | translate }}</h4>
              <h3 class="dtfbrochures__header6" *ngIf="filter()">{{totalFilteredCost() | currency}}</h3>
            </div>
          </section>
        </div>
      </div>
    </div>

    <div *ngIf="!tableLoaded()" class="mbfs-payoff-quote-spinner" style="margin-bottom: 20px;">
      <!--Spinner on Login Load-->
      <div class="demo-container">
        <span>{{ 'Invoice.Loading' | translate }}</span>
        <div class="progress-bar">
          <div class="progress-bar-value"></div>
        </div>
      </div>
      <br>
    </div>

    
      <div class="cardlike">
        <div class="accountflex">
          <h1 class="mercedes-me-login__column-headline2">{{ 'AccountDetails.Contracts' | translate }}</h1>
          <mat-form-field class="example-form-field" appearance="outline">
            <mat-label>{{ 'AccountDetails.Search' | translate }}</mat-label>
            <input matInput (keyup)="applyFilter($event)" placeholder="Contract Number or Status" #input type="text"
              [(ngModel)]="value">
            <img matSuffix class="example-form-img"
              src="/static/assets/img/dtf-assets/images/redesign/DTF_SearchButton_copy.png">
          </mat-form-field>
        </div>
        <p class="paragraph1"> {{ 'AccountDetails.ContractsParagraph' | translate }}</p>
      </div>
      <br>

      <button style="float: right;" class="mbfs-button" (click)="exportToExcel()">{{ 'AccountDetails.export' | translate
        }}</button>


      <div class="example-button-row" style=" justify-content: left !important;"
        *ngIf="!bodyLoaded() && !isCanadaPortal()">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState()"
          (change)="onChange($event)">
          <mat-button-toggle [value]="toggleEnum.Option1">{{ 'AccountDetails.Loans' | translate }}</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option2">{{ 'AccountDetails.Leases' | translate }}</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option3">{{ 'AccountDetails.Mature' | translate }}</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option4">{{ 'AccountDetails.Terminated' | translate
            }}</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option5">{{ 'AccountDetails.Dynamic' | translate }}</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option6">{{ 'AccountDetails.ViewAll' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <div class="example-button-row" *ngIf="!bodyLoaded() && isCanadaPortal()">
        <mat-button-toggle-group [hideSingleSelectionIndicator]="true" [value]="selectedState()"
          (change)="onChange($event)">
          <mat-button-toggle [value]="toggleEnum.Option1">{{ 'AccountDetails.Loans' | translate }}</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option2">{{ 'AccountDetails.Leases' | translate }}</mat-button-toggle>
          <!-- <mat-button-toggle [value]="toggleEnum.Option3">{{ 'AccountDetails.Mature' | translate }}</mat-button-toggle> -->
          <mat-button-toggle [value]="toggleEnum.Option4">{{ 'AccountDetails.Terminated' | translate
            }}</mat-button-toggle>
          <mat-button-toggle [value]="toggleEnum.Option6">{{ 'AccountDetails.ViewAll' | translate }}</mat-button-toggle>
        </mat-button-toggle-group>
      </div>
      <!-- <button (click)="formatAccountURl('dynamic')" href="javascript:void(0);">{{ 'AccountDetails.Dynamic' | translate }}</button> -->

      <!--Mat Table for US / CA-->
      
        <mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
          <!--US/EN Table loading-->
          <ng-container matColumnDef="{{column.name}}" *ngFor="let column of initColumns; last as isLast">
            <mat-header-cell mat-sort-header mat-header-cell *matHeaderCellDef style="justify-content: center;">
              <div *ngIf="!isFrench()"> {{column.display}}</div>
              <div *ngIf="isFrench()"> {{column.displayFR}}</div>
            </mat-header-cell>
            <mat-cell *matCellDef="let element" style="justify-content: center;">
              <span class="mobile-label">
                <div *ngIf="!isFrench()"> {{column.display}} :</div>
                <div *ngIf="isFrench()"> {{column.displayFR}} :</div>
              </span>
              <div *ngIf="column.dispFormat=='currency'"> <!--Formats Currency Columns-->
                {{element[column.name] | currency:'USD':true:'1.2-2'}}
              </div>
              <div *ngIf="column.dispFormat=='contract'"> <!--Formats Contract String Columns-->
                <mat-icon *ngIf="element.newAcctAdded">
                  <img matSuffix class="example-form-img"
                    src="static/assets/img/dtf-assets/images/DTF_Icons/NewFlag.png">
                </mat-icon>
                {{element[column.name]}}
              </div>
              <div *ngIf="column.dispFormat==''"> <!--Formats String Columns-->
                {{element[column.name]}}
              </div>
              <div *ngIf="column.dispFormat=='date'"> <!--Formats date Columns-->
                {{element[column.name] | date:'MM/dd/yyyy'}}
              </div>
              <mat-icon *ngIf="isLast">&nbsp;{{element == expandedAccount() ? 'expand_less' : 'expand_more'}}</mat-icon>

            </mat-cell>
          </ng-container>

          <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
          <ng-container matColumnDef="accountDetailsRes">
            <mat-cell class="example-element-detailed-row2" mat-cell *matCellDef="let element"
              [attr.colspan]="displayedColumns.length">
              <div class="example-element-detail"
                [@detailExpand]="element == expandedAccount() ? 'expanded' : 'collapsed'">
                <div class="example-element-diagram">
                  <!-- <div class="example-element-contractNum"> {{element.contractNum}} </div>
                <div class="example-element-lastPayRcvd"> {{element.lastPayRcvd}} </div>
                <div class="example-element-contractType"> {{element.contractType}} </div>
                <div class="example-element-termDate"> {{element.termDate}} </div>
                <div class="example-element-totalDue"> {{element.totalDue}} </div>
                <div class="example-element-currentDt"> {{element.currentDt}} </div> -->
                </div>
                <div class="example-element-description" *ngIf="isCanadaPortal()">
                  <a (click)="checkUrl('payoff')" *ngIf="element.status !=='TERMINATED'" href="javascript:void(0);"
                    class="link2">{{ 'AccountDetails.PayoffButton' | translate }}</a>
                  <a *ngIf="element.status ==='LIVE' && !element.terminationQuoteBlocked"
                    (click)="checkUrlParam('payoff', element.contractNum)" href="javascript:void(0);" class="link2">{{
                    'AccountDetails.MakePayoff' | translate }}</a>
                  <!-- <a *ngIf="element.contractType ==='LOAN'" (click)="checkUrlParam('amortization', element.contractNum)" href="javascript:void(0);" class="link2">{{ 'AccountDetails.AmortButton' | translate }}</a> -->
                  <!--<a (click)="checkUrl('pay')" href="javascript:void(0);" class="link2">{{ 'AccountDetails.PaymentOptionsButton' | translate }}</a>-->
                </div>
                <div class="example-element-description" *ngIf="!isCanadaPortal()">
                  <!-- <a (click)="checkUrl('invoice')" href="javascript:void(0);" class="link2">{{ 'AccountDetails.InvoiceButton' | translate }}</a> -->
                  <!-- <a *ngIf="element.contractType ==='LOAN'" (click)="checkUrlParam('amortization', element.contractNum)" href="javascript:void(0);" class="link2">{{ 'AccountDetails.AmortButton' | translate }}</a> -->
                  <!-- <a *ngIf="element.status !=='TERMINATED'" (click)="checkUrl('pay')" href="javascript:void(0);" class="link2">{{ 'AccountDetails.PayNowButton' | translate }}</a> -->
                  <a *ngIf="element.status ==='LIVE' && element.contractType ==='LOAN' && !element.terminationQuoteBlocked"
                    (click)="checkUrlParam('payoff', element.contractNum)" href="javascript:void(0);" class="link2">{{
                    'AccountDetails.MakePayoff' | translate }}</a>
                  <a *ngIf="element.status ==='Dynamic / LIVE'" (click)="checkUrlParam('dynamic', element.contractNum)"
                    href="javascript:void(0);" class="link2">{{ 'AccountDetails.DynamicFinancing' | translate }}</a>
                </div>
              </div>
            </mat-cell>
          </ng-container>

          <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row"
            [class.example-expanded-row]="expandedAccount() === element"
            (click)="expandedAccount.set(expandedAccount() === element ? null : element)">
          </mat-row>
          <mat-row *matRowDef="let row; columns: ['accountDetailsRes']" class="example-detail-row"></mat-row>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="4" *ngIf="!isFrench()">No data matching the filter "{{input.value}}"</td>
            <td class="mat-cell" colspan="4" *ngIf="isFrench()">Aucune donnée correspondant au filtre "{{input.value}}"
            </td>
          </tr>

        </mat-table>
        <mat-paginator [pageSizeOptions]="[10, 25, 100]"></mat-paginator>
        <br>
      
   
  </div>
  <br>
  <br>
</div>